import * as React from "react";

import { cn } from "@/shared/utils/utils";
import type { MeterSummaryTileSkeletonProps } from "@/shared/type/skeleton.type";
import { Skeleton } from "./skeleton";

export const MeterSummaryTileSkeleton = ({
  className,
  ...props
}: MeterSummaryTileSkeletonProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "flex-1 rounded-20 bg-primary p-4 min-[480px]:p-6 flex flex-col gap-4.5 justify-between",
        className,
      )}
      {...props}
    >
      <div className="info-block">
        {/* Icon */}
        <Skeleton className="mb-4 sm:mb-5 max-xs:size-10 xs:size-16 rounded-md bg-pure-white/15" />

        {/* Total count */}
        <Skeleton className="h-10 sm:h-11 md:h-12 lg:h-13 w-24 mb-1 bg-pure-white/15" />

        {/* Meter Summary */}
        <Skeleton className="h-5 sm:h-6 md:h-7 w-36 bg-pure-white/15" />
      </div>

      {/* Show Inactive + Switch */}
      <div className="flex items-center gap-5 max-sm:gap-2 justify-end">
        <Skeleton className="h-5 w-24 bg-pure-white/15" />

        <Skeleton className="h-6 w-11 rounded-full bg-pure-white/15" />
      </div>
    </div>
  );
};
